import {Avatar} from 'antd'
import React from "react";

export const FListAvatar: React.FC<{character: string, size?: number}> = ({character, size}) => {
    const avatarLink = `https://static.f-list.net/images/avatar/${character.toLowerCase()}.png`;
    return (
        <Avatar size={size} src={avatarLink} shape={"square"}/>
    )
};
